export const getEnumKeys = (enumType: Object): string[] => {
    return Object.keys(enumType).filter(
        (key) => Number.isNaN(Number(key)) && key !== 'values'
    )
}
